import axios from "axios";
import { filesUrl, formApiWordTemplatesUrl } from "../Config/Url";

const getWordTemplates = (params) =>
  axios
    .get(formApiWordTemplatesUrl, {
      params,
    })
    .then((r) => r)
    .catch((e) => e.response);

const postWordTemplates = async (body) => {
  return axios.post(formApiWordTemplatesUrl, body);
};
const putWordTemplates = async (body) => {
  return axios.put(formApiWordTemplatesUrl, body);
};

const getWordTemplateById = (id) =>
  axios
    .get(`${formApiWordTemplatesUrl}/${id}`)
    .then((r) => r)
    .catch((e) => e.response);

const postWordTemplatesAttachments = async ({ wordTemplateId, ...file }) => {
  return axios.post(
    `${formApiWordTemplatesUrl}/${wordTemplateId}/attachments`,
    {
      wordTemplateId,
      ...file,
    },
  );
};

const deleteWordTemplatesAttachments = async ({
  wordTemplateId,
  attachmentId,
}) => {
  return axios.delete(
    `${formApiWordTemplatesUrl}/${wordTemplateId}/attachments/${attachmentId}`,
  );
};

const deleteWordTemplate = (id) =>
  axios
    .delete(`${formApiWordTemplatesUrl}/${id}`)
    .then((r) => r)
    .catch((e) => e.response);

const getActiveWordTemplates = () =>
  axios
    .get(`${formApiWordTemplatesUrl}/active`)
    .then((r) => r)
    .catch((e) => e.response);

const downloadWordTemplateFile = ({
  // fileId = "72d54240-1a8b-42e6-b634-09b8521f832c",
  fileId,
}) => {
  return axios
    .get(`${filesUrl}?fileId=${fileId}`, {
      responseType: "arraybuffer",
    })
    .then((r) => r)
    .catch((e) => e.response);
};

const postAttachment = ({ wordTemplateId, ...body }) =>
  axios
    .post(`${formApiWordTemplatesUrl}/${wordTemplateId}/attachments`, {
      wordTemplateId,
      ...body,
    })
    .then((r) => r)
    .catch((e) => e.response);

const getWordTemplateStatuses = () =>
  axios
    .get(`${formApiWordTemplatesUrl}/statuses`, {
      responseType: "arraybuffer",
    })
    .then((r) => r)
    .catch((e) => e.response);

const postSendMail = (body) =>
  axios
    .post(`${formApiWordTemplatesUrl}/send-mail`, body)
    .then((r) => r)
    .catch((e) => e.response);

export default {
  getWordTemplates,
  postWordTemplates,
  putWordTemplates,
  getWordTemplateById,
  postWordTemplatesAttachments,
  deleteWordTemplatesAttachments,
  deleteWordTemplate,
  getActiveWordTemplates,
  downloadWordTemplateFile,
  postAttachment,
  getWordTemplateStatuses,
  postSendMail,
};
